import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  process.env.TWENTY_API_URL,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {
  searchBookingList(request) {
    return conduit.post('/booking/gift-voucher-accept/search-bookings', request, []);
  },
  searchEmailList(domain) {
    return conduit.get(`/booking/gift-voucher-accept/domains/${domain}`, [], []);
  },
  sendMails(bookingIds) {
    return conduit.post('/booking/gift-voucher-accept/dispatch-emails', { bookingIds }, []);
  },
};



// WEBPACK FOOTER //
// ./src/services/gift-voucher-service.js